import { A04 } from 'api/U003';

export const postMypageAttachedFile = async (user_id: string, filePath: string) => {
  try {
    const json = await A04({ user_id: user_id, filePath: filePath });
    const response = await fetch(json.url);
    if (!response.ok) {
      throw new Error('failed to fetch file');
    }
    const blob = await response.blob();
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.download = json.fileName;
    a.click();

    return {
      response: response,
    };
  } catch (err: unknown) {
    console.error(err);
    return null;
  }
};
